import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';

export default function ArticlePage() {
  const article = articleData['is-sugargoo-legit-safe'];
  return <ArticleLayout article={article} />;
}